import * as angular from 'angular';

class NetworkPointBundleCreateSurchargeSplitUpCtrl implements ng.IController {
    constructor() {}

    public bundleRequest: BundleChangeRequestDto;
    public readonly: boolean;
    public chargeSplitUpLeftOverTypes: LeftOverSplitUpMode[] = [
        'SPLIT_FACTOR_AUCTION_CHARGE',
        'SPLIT_FACTOR_CAPACITY_CHARGE'
    ];
    public chargeSplitUpLongTermTypes: LongTermSplitUpStrategy[] = [
        'SPLIT_FACTOR',
        'PRICE_STEPS'
    ];

    $onInit() {
        if (!this.bundleRequest.newChargeSplitUpLeftOver) {
            this.bundleRequest.newChargeSplitUpLeftOver =
                'SPLIT_FACTOR_AUCTION_CHARGE';
        }
        if (!this.bundleRequest.newChargeSplitUpLongTerm) {
            this.bundleRequest.newChargeSplitUpLongTerm = 'SPLIT_FACTOR';
        }
    }
}

angular.module('app').component('pkpNetworkPointBundleCreateSurchargeSplitUp', {
    controller: NetworkPointBundleCreateSurchargeSplitUpCtrl,
    template:
        require('app/network-point-bundle/network-point-bundle-create-surcharge-split-up.component.html'),
    bindings: {
        form: '=',
        readonly: '<',
        bundleRequest: '='
    }
});
